export default "/_next/static/chunks/fonts/DMMono-Regular-96c71e61f234e8501a03bf586f93e61a.woff2";